// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".multi-button-action_7c81 {\n  display: inline-block;\n  position: relative;\n}", "",{"version":3,"sources":["/home/runner/work/telemetry/telemetry/ts/packages/frontend/src/component/Observe/MultiActionButton.scss","MultiActionButton.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;EACA,kBAAA;ACCJ","file":"MultiActionButton.scss","sourcesContent":[".multi-button-action {\n    display: inline-block;\n    position: relative;\n}\n",".multi-button-action {\n  display: inline-block;\n  position: relative;\n}"]}]);
// Exports
exports.locals = {
	"multi-button-action": "multi-button-action_7c81"
};
module.exports = exports;
